import { Injectable } from '@angular/core';

import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';

import { Bracelet } from '../models/bracelet.model';
import { Dessert } from '../models/dessert.model';
import { Food } from '../models/food.model';

@Injectable()
export class DvlSettingsService {
  public bracelets$: FirebaseListObservable<Bracelet[]>;
  public desserts$: FirebaseListObservable<Dessert[]>;
  public foods$: FirebaseListObservable<Food[]>;
  public timetable$: FirebaseListObservable<any[]>;

  constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase) {
    this.bracelets$ = af.list('/bracelets');
    this.desserts$ = af.list('/desserts');
    this.foods$ = af.list('/foods');
    this.timetable$ = af.list('/timetable');
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/services/settings.service.ts